module.exports = require('./helpers/bundle-url').getBundleURL('aBKVY') + "logo-dark.ba5147f0.svg";